const SvgExpandMore = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width='1em' height='1em' viewBox='0 0 24 24' fill='none' {...props}>
      <path d='M16.59 8.297L12 12.877l-4.59-4.58L6 9.707l6 6 6-6-1.41-1.41z' fill='currentColor' />
    </svg>
  );
};

export default SvgExpandMore;
